import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosCustom } from '../../../utils/axiosUser';

export const initStateServiceGenerateKey = {
  serviceGenerateKey: { data: null, loading: false, error: null },
};

export const serviceGenerateKey = createAsyncThunk('user/serviceGenerateKey', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosCustom
    .post(`/service/generate-key`, data)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerServiceGenerateKey = {
  [serviceGenerateKey.pending]: (state) => {
    state.serviceGenerateKey.loading = true;
  },
  [serviceGenerateKey.fulfilled]: (state, action) => {
    state.serviceGenerateKey.loading = false;
    state.serviceGenerateKey.data = action.payload;
    state.serviceGenerateKey.error = null;
  },
  [serviceGenerateKey.rejected]: (state, action) => {
    state.serviceGenerateKey.loading = false;
    state.serviceGenerateKey.error = action.payload;
  },
};
